import React from "react";
import { cn } from "../../lib/cn";

/**
 * Dashboard stat: Space Grotesk number, green icon chip, optional delta pill.
 * `delta` is only rendered when supplied. Do not pass invented figures.
 */
export function Stat({ value, label, suffix, icon, delta, deltaTone = "success", className }) {
  const toneCls =
    deltaTone === "danger" || deltaTone === "warn" || deltaTone === "warning"
      ? "text-warning bg-warning/10 ring-warning/25"
      : deltaTone === "neutral" || deltaTone === "info"
      ? "text-info bg-info/10 ring-info/25"
      : "text-primary bg-primary/10 ring-primary/30";
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      {icon && (
        <span className="mb-2 inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary/10 text-primary">
          {icon}
        </span>
      )}
      <div className="flex items-baseline gap-1">
        <span className="glow-num text-2xl font-bold leading-none">{value}</span>
        {suffix && <span className="glow-num text-sm font-semibold">{suffix}</span>}
      </div>
      <div className="mt-1 text-xs font-medium text-text">{label}</div>
      {delta && (
        <span className={cn("mt-1.5 inline-flex w-fit items-center gap-1.5 rounded px-2 py-0.5 text-xs font-semibold ring-1 ring-inset", toneCls)}>
          <span className="h-1.5 w-1.5 rounded-full bg-current" />
          {delta}
        </span>
      )}
    </div>
  );
}

export default Stat;
